export const RECENT_WORKSPACES_STORAGE_KEY = 'timelining-recent-workspaces'
export const MAX_RECENT_WORKSPACES = 8

/**
 * Reads recent workspace IDs from localStorage.
 */
export const getRecentWorkspaceIds = (): string[] => {
  if (typeof window === 'undefined') return []
  try {
    const raw = window.localStorage.getItem(RECENT_WORKSPACES_STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed)
      ? parsed.filter((value): value is string => typeof value === 'string')
      : []
  } catch {
    return []
  }
}

/**
 * Records a workspace ID to the front of recent workspaces in localStorage.
 * Keeps up to MAX_RECENT_WORKSPACES items.
 */
export const recordRecentWorkspaceId = (workspaceId: string): string[] => {
  if (!workspaceId) return getRecentWorkspaceIds()
  const current = getRecentWorkspaceIds()
  const next = [workspaceId, ...current.filter((id) => id !== workspaceId)].slice(0, MAX_RECENT_WORKSPACES)
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(RECENT_WORKSPACES_STORAGE_KEY, JSON.stringify(next))
    } catch {
      // ignore
    }
  }
  return next
}
